import { Input, Select, styled } from '@mui/material';

const ITEM_HEIGHT = 49;
const ITEM_PADDING_TOP = 8;

export const UPSelectStyled = styled(Select)(({ theme }) => ({
  height: ITEM_HEIGHT,
  borderRadius: '4px',
  background: 'white',
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
}));

export const DropdownPlaceholder = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: '14px',
}));

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

export const UPDropdownHelperText = styled('p')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.error.main,
  marginTop: '3px',
  marginBottom: '0px',
}));

export const CompanyNameInputStyled = styled(Input)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const TriggerButton = styled('button', {
  shouldForwardProp: prop => prop !== 'textColor',
})<{ textColor?: string }>(({ textColor = '#FFFFFF' }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: textColor,
  padding: 0,
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  '& .MuiSvgIcon-root': {
    color: textColor,
    fill: textColor,
  },
}));
